module.exports = __webpack_public_path__ + "img/vote.c59d638e.png";